// CSS
import '../../sass/third-party/single-alpha_car_ads.scss'

// Galerie dupliquée : 1 instance mobile (au-dessus de la sticky bar) + 1 instance desktop.
// Pour chaque bouton "Voir la galerie", on déclenche la 1re miniature de SA galerie (même wrapper).
document.querySelectorAll('.car-gallery-link').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault()
    const wrapper = btn.closest('.car-gallery-wrap')
    const firstImg = wrapper?.querySelector('.image-gallery-link')
    firstImg?.click()
  })
})
